import type { SVGProps } from 'react';

export const ImportSmall = (props: SVGProps<SVGSVGElement>) => (
    <svg fill='currentColor' xmlns='http://www.w3.org/2000/svg' width='10' height='12' {...props}>
        <path d='M10 4.169 6.414.584a2.003 2.003 0 0 0-2.828 0L0 4.17l1.414 1.414L4 2.998V12h2V2.998l2.586 2.586L10 4.169Z' />
    </svg>
);
